namespace TabAurous.Administration {
    export interface QualityInspectionTemplateDetailsForm {
        Parameter: Serenity.StringEditor;
        Value: Serenity.StringEditor;
        IsNumeric: Serenity.BooleanEditor;
        Min: Serenity.DecimalEditor;
        Max: Serenity.DecimalEditor;
    }

    export class QualityInspectionTemplateDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.QualityInspectionTemplateDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QualityInspectionTemplateDetailsForm.init)  {
                QualityInspectionTemplateDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(QualityInspectionTemplateDetailsForm, [
                    'Parameter', w0,
                    'Value', w0,
                    'IsNumeric', w1,
                    'Min', w2,
                    'Max', w2
                ]);
            }
        }
    }
}
